import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { TestForm } from '@/components/test/TestForm';

const testPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();

  // Redirect if not authenticated
  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate('/auth/login', { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  // Don't render anything while checking auth or if not authenticated
  if (loading || !isAuthenticated) {
    return null;
  }

  return <TestForm />;
};

export default testPage;
